import React from 'react';

// Cms data
import { usePrismicNavigation } from 'hooks/usePrismicNavigation';
import { usePrismicFooterContactLinks } from 'hooks/usePrismicFooterContactLinks';

export const useNavigationOverlay = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const navigationData = usePrismicNavigation();
  const data = navigationData?.data;

  const footerData = usePrismicFooterContactLinks();
  const contactLinksData = footerData?.data;

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return [
    // So we dont need to pas the overlay again
    {
      isOpen,
      pageLinks: data?.page_links,
      language: data?.language?.[0],
      contactLinks: contactLinksData?.contact_links,
      handleClose
    },
    // Navigation Controls
    {
      handleOpen,
      handleClose
    }
  ];
};
